import React, { useState } from 'react'
import { Form, Select } from 'formik-antd'

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0

const initialCategoryList = (props) => {
  if (props.formik.values.service === undefined) {
    return false
  }

  const services = props.services.filter((item) => item?.id == props.formik.values.service)

  const categoriesIds = services.reduce(
    (a, currentValue) => [...a, ...(currentValue.categories || []).map((item) => item.id)],
    []
  )

  const categories = props.categories.filter((item) => categoriesIds.indexOf(item?.id) !== -1)

  return categories
}

const initialUnitList = (props) => {
  if (props.formik.values.service === undefined) {
    return false
  }

  const services = props.services.filter((item) => item?.id == props.formik.values.service)

  const unitsIds = services.reduce(
    (a, currentValue) => [...a, ...(currentValue.units || []).map((item) => item.id)],
    []
  )

  const units = props.units.filter((item) => unitsIds.indexOf(item?.id) !== -1)

  return units
}

const Subform = (props) => {
  const [listOfUnits, setListOfUnits] = useState(initialUnitList(props))
  const [listOfCategories, setListOfCategories] = useState(initialCategoryList(props))

  const onChangeLanguageFamily = (current, values, setFieldValue) => {
    setFieldValue('language', '')
  }

  const changeServices = (current, values, setFieldValue) => {
    if (current === undefined) {
      setListOfCategories([])
      setFieldValue('languageFamily', '')
      setFieldValue('category', '')
      return
    }

      const service = props.services.find((item) => item?.id == current)

    if (service) {
      setFieldValue('languageType', service.language)
      const categoriesIds = (service.categories || []).map((item) => item.id)
      const unitsIds = (service.units || []).map((item) => item.id)

      const categories = props.categories.filter((item) => categoriesIds.indexOf(item?.id) !== -1)
      setListOfCategories(categories)

      const units = props.units.filter((item) => unitsIds.indexOf(item?.id) !== -1)
      setListOfUnits(units)
    } else {
      setListOfUnits([])
      setListOfCategories([])
    }
  }

  const onChangeUnit = (id) => {
    const { setFieldValue } = props.formik

    if (id == 1) {
      setFieldValue('isWord', true)
      setFieldValue('catlog', '')
      setFieldValue('amount', '')
    } else {
      setFieldValue('isWord', false)
      setFieldValue('catlog', '')
      setFieldValue('amount', '')
    }
  }

  const showLanguagePairBasedOnServices = (values) => {
    if (values.service === undefined) {
      return false
    }

    const services = props.services.filter((item) => item?.id == values.service)

    return services.some((item) => item.language === 'Pair')
  }

  const showLanguageBasedOnServices = (values) => {
    if (values.service === undefined) {
      return false
    }

    const services = props.services.filter((item) => item?.id == values.service)

    return services.some((item) => item.language === 'Single')
  }

  const { values, setFieldValue } = props.formik
  return (
    <>
      <Form.Item label='Service' name='service' showValidateSuccess hasFeedback required>
        <Select
          name='service'
          style={{ width: '100%' }}
          placeholder='Service'
          options={props.services}
          filterOption={_filter}
          onChange={(val) => changeServices(val, values, setFieldValue)}
          showSearch
          allowClear
        />
      </Form.Item>

      {(listOfCategories || []).length > 0 && (
        <Form.Item label='Category' name='category'>
          <Select
            name='category'
            style={{ width: '100%' }}
            placeholder='Category'
            options={listOfCategories}
            filterOption={_filter}
            showSearch
            allowClear
          />
        </Form.Item>
      )}

      {showLanguageBasedOnServices(values) && (
        <Form.Item label='Language Family' name='languageFamily'>
          <Select
            name='languageFamily'
            style={{ width: '100%' }}
            placeholder='Language Family'
            showSearch
            allowClear
            onChange={(val) => onChangeLanguageFamily(val, values, setFieldValue)}
          >
            <Select.Option value='' />
            <Select.Option value='LTR'>LTR</Select.Option>
            <Select.Option value='RTL'>RTL</Select.Option>
          </Select>
        </Form.Item>
      )}

      {showLanguageBasedOnServices(values) && !values.languageFamily && (
        <Form.Item label='Language' name='language'>
          <Select
            name='language'
            style={{ width: '100%' }}
            placeholder='Language'
            options={props.languages}
            filterOption={_filter}
            showSearch
            allowClear
          />
        </Form.Item>
      )}

      {showLanguagePairBasedOnServices(values) && (
        <Form.Item label='Language Pair' name='languagePair'>
          <Select
            name='languagePair'
            style={{ width: '100%' }}
            placeholder='Language Pair'
            options={props.languagePairs}
            filterOption={_filter}
            showSearch
            allowClear
          />
        </Form.Item>
      )}

      <Form.Item label='Unit' name='unit' showValidateSuccess hasFeedback required>
        <Select
          name='unit'
          style={{ width: '100%' }}
          placeholder='Unit'
          options={listOfUnits}
          filterOption={_filter}
          onChange={onChangeUnit}
          showSearch
          allowClear
        />
      </Form.Item>
    </>
  )
}
export default Subform
